import React, { useEffect, useState } from 'react';
import { Typography, AppBar, Tab, Tabs, Tooltip } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div p={3}>
                    <Typography component="div">{children}</Typography>
                </div>
            )}
        </div>
    );
}

export default function TabsPanel({
    tabs,
    counter,
    setCounter,
    onChange = (value) => {},
}) {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = createSearchParams(location.search).get('tab');

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        navigate({
            pathname: location.pathname,
            search: `tab=${newValue}`,
        });
        setValue(newValue);
        setCounter(counter + 1);
        onChange(newValue);
    };

    useEffect(() => {
        if (
            searchParams == null ||
            searchParams >= tabs.length ||
            tabs[parseFloat(searchParams)].disabled
        ) {
            setValue(0);
        } else {
            setValue(parseFloat(searchParams));
        }
    }, [searchParams, tabs]);

    return (
        <div className="mt-16">
            <AppBar position="static" className="rounded-t-8">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                    className="bg-true-blue rounded-t-8 "
                >
                    {tabs.map((tab, index) => (
                        <Tooltip title={tab.tooltip} arrow key={index}>
                            {tab.disabled ? (
                                <span>
                                    <Tab
                                        label={tab.label}
                                        icon={
                                            <LockOutlinedIcon fontSize="small" />
                                        }
                                        iconPosition="start"
                                        disabled={tab.disabled}
                                    />
                                </span>
                            ) : (
                                <Tab
                                    label={tab.label}
                                    disabled={tab.disabled}
                                />
                            )}
                        </Tooltip>
                    ))}
                </Tabs>
            </AppBar>
            {tabs.map((tab, index) => (
                <TabPanel
                    key={index}
                    value={value}
                    index={index}
                    className="bg-white p-16 rounded-b-8"
                >
                    {tab.component}
                </TabPanel>
            ))}
        </div>
    );
}
